import { authCopy } from "./authCopy";

const HOME_PT = {
  live: "AO VIVO",
  greeting: "Personal Shopper de Luxo",
  welcome: "Bem-vinda,",
  welcomeAccent: "amiga.",
  subtitle:
    "Peças selecionadas com exclusividade, achados raros e oportunidades únicas — o luxo que você merece, todos os dias.",
  todayPromos: "Promoções de Hoje",
  customizePromo: "Personalizar promo",
  auctions: "Leilões",
  auctionsOpen: (n) => `${n} leilão${n > 1 ? "s" : ""} aberto${n > 1 ? "s" : ""} agora!`,
  auctionsEmpty: "Leilão off — oportunidades no grupo VIP",
  seeAllAuctions: "Ver todos os leilões",
  news: "Novidades",
  newsSub: "News e atualizações da Madamy Closet.",
  superPromos: "Super Promos",
  superPromosSub: "Combos exclusivos com preços imperdíveis!",
  newBadge: "NOVO",
  gift: "Receber Presente",
  giftSub: "Gire a roleta e ganhe prêmios!",
  testimonial: "Envie seu Depoimento",
  testimonialSub: "Mande o vídeo pelo WhatsApp e libere seu presente!",
  explore: "Explorar",
  refer: "Indique Amigas",
  referDesc: "Ganhe pontos por cada indicação.",
  points: "Meus Pontos",
  pointsDesc: "Veja seu saldo e histórico.",
  instagram: "Instagram",
  instagramDesc: "Bastidores, drops e novidades.",
  website: "Nosso Site",
  websiteDesc: "Catálogo completo e contato.",
  talk: "Falar Conosco",
  feedback: "Feedback & Sugestões",
  send: "Enviar",
  install: "Instale o app para melhor experiência",
  installTitle: "Instale o nosso app",
  installAndroid:
    "Clique na janela que aparecerá no rodapé da página ou clique em adicione o App à tela inicial do seu smartphone",
  installIos: "Siga as etapas abaixo e instale o nosso app em seu dispositivo",
  installApp: "Instalar Aplicativo",
  step1: "Clique no símbolo de compartilhar do navegador",
  step2: 'Procure o botão "Adicionar à Tela de início"',
  step3: "Adicione o app à tela de início",
  add: "Adicionar",
  sendTestimonial: "Envie seu Depoimento",
  loadingHistory: "Carregando seu histórico...",
  approved: "Depoimento Aprovado!",
  reviewing: "Depoimento em Análise",
  approvedBody: "Seu vídeo foi aprovado e já pode aparecer nos nossos Stories! Obrigada por compartilhar.",
  reviewingBody: "Recebemos seu vídeo e estamos analisando. Seu giro na roleta já foi creditado!",
  sentOn: "Enviado em",
  close: "Fechar",
  testimonialSent: "Depoimento enviado!",
  testimonialSentBody: "Obrigada por compartilhar sua experiência! Seu giro na roleta foi creditado.",
  testimonialDesc:
    "Envie um vídeo curto contando sua experiência com a Madamy Closet pelo WhatsApp — é mais rápido e sem limite de tamanho no app.",
  rule1: "Grave um vídeo contando o que achou do produto e da entrega",
  rule2: "Envie direto no WhatsApp da Madamy Closet",
  rule3: "Assim liberamos o envio do seu presente da roleta",
  openWa: "Abrir WhatsApp",
  thanksFeedback: "Obrigada pelo feedback!",
  thanksFeedbackBody: "Sua opinião é muito importante para nós. Vamos analisar sua sugestão com carinho.",
  feedbackDesc:
    "Conte pra gente o que achou do app, o que podemos melhorar ou o que você gostaria de ver por aqui.",
  feedbackPh: "Escreva aqui sua sugestão...",
  sendFeedback: "Enviar Feedback",
  ticker:
    "✨ Peças 100% originais e autenticadas  •  📦 Frete para todo o Brasil  •  💎 Curadoria exclusiva diária  •  ⭐ +500 clientes satisfeitas  •  🔒 Compra segura e protegida  •  💳 Parcele em até 12x  •  🎁 Presente para novas membros  •  ",
  ended: "Encerrado",
  currentBid: "Lance atual",
  bids: "lances",
  seeAuctions: "Ver Leilões",
  liveAuction: "LEILÃO AO VIVO",
  spinLine: (n) => `Você tem ${n} giro${n > 1 ? "s" : ""} na Roleta de Presentes!`,
  nextBenefit: "Seu próximo benefício:",
  nextBuy: "— na próxima compra!",
  freeShip: "Frete Grátis Nacional (Sedex)",
  testimonialAlert: "Envie seu depoimento em vídeo pelo WhatsApp para liberar o envio! Clique aqui.",
  dispute: "Dispute peças exclusivas com lances.",
  seeProducts: "Ver produtos →",
  exclusiveVip: "EXCLUSIVO VIP",
  soldOut: "ESGOTADO",
  noProduct: "Nenhum produto",
  unitPrice: "Avulso",
  storeLabel: "Preço na loja",
  ourPrice: "Nosso preço",
  wantBuy: "Quero comprar",
  superTitle: "Super Promos",
  superSub: "Combos exclusivos com preços imperdíveis",
  surpriseKicker: "Entrada surpresa",
  surpriseTitle: "As Super Promos do dia entram às 06:00",
  surpriseBody: "Fica no relógio. Quem chega cedo pega o kit novo.",
  noPromo: "A qualquer momento tem mais.",
  noPromoTitle: "Encerrada por hoje",
  back: "Voltar",
  oops: "Ops! Algo deu errado",
  oopsBody: "Estamos trabalhando para resolver. Tente recarregar a página.",
  reload: "Recarregar",
  notFound: "Página não encontrada",
  backHome: "Voltar ao Início",
  bags: "Bolsas",
  travel: "Malas de Viagem",
  watches: "Relógios",
  accessories: "Acessórios",
  jewelry: "Joias",
  clothes: "Roupas",
  shoes: "Calçados",
  other: "Outros",
  storyLabels: { leilao: "Leilão", achados: "Achados", depoimentos: "Clientes", envios: "Envios", duvidas: "Dúvidas" },
  loadingDots: "Carregando...",
  piece: "peça",
  pieces: "peças",
  availableCount: (n) => `${n} peça${n !== 1 ? "s" : ""} disponíve${n !== 1 ? "is" : "l"}`,
  removeFav: "Remover dos favoritos",
  saveFav: "Salvar nos favoritos",
  pieceNoun: "Peça",
  notifyTitle: "Ative as notificações!",
  notifyBody: "Instale o app para receber alertas de novos leilões e lances em tempo real.",
  wishAsk: "O que você quer ver no leilão?",
  wishHint: "Clique aqui e sugira a peça dos seus sonhos",
  wishSentBanner: "✨ Sugestão enviada! Obrigada!",
  filterActive: "Ativos",
  filterSoon: "Em Breve",
  filterEnded: "Encerrados",
  loadAuctionsErr: "Erro ao carregar leilões",
  wishSendErr: "Erro ao enviar sugestão",
  noAuctionActive: "Nenhum leilão ativo no momento",
  noAuctionSoon: "Nenhum leilão em breve",
  noAuctionEnded: "Nenhum leilão encerrado",
  auctionOffTitle: "Leilão off agora",
  auctionOffBody: "Fica ligada no grupo — as oportunidades aparecem por lá. Ative as notificações dos nossos canais.",
  auctionOffGroupCta: "Entrar no grupo VIP",
  auctionOffNotifyHint: "Ative as notificações do app e fique de olho no WhatsApp para não perder a próxima disputa.",
  auctionsEmptyOff: "Leilão off — oportunidades no grupo VIP",
  loadingAuctions: "Carregando leilões...",
  placeBid: "Dar Lance",
  wishThanksTitle: "Obrigada pela sugestão!",
  wishThanksBody: "Vamos analisar e trazer para o próximo leilão.",
  wishPopupTitle: "O que você quer ver no leilão?",
  wishPopupSub: "Conte pra gente qual peça ou marca você sonha em arrematar!",
  category: "Categoria",
  yourSuggestion: "Sua sugestão",
  wishPlaceholder: "Ex: Bolsa Chanel Classic Flap, Tênis Louis Vuitton Trainer...",
  sending: "Enviando...",
  sendSuggestion: "Enviar Sugestão",
  auctionDetails: "Detalhes do Leilão",
  loadAuctionErr: "Erro ao carregar leilão",
  auctionNotFound: "Leilão não encontrado",
  minBidToast: (v) => `Lance mínimo: R$ ${v}`,
  bidOk: "Lance realizado com sucesso!",
  bidFail: "Erro ao fazer lance",
  highestBidder: "Maior lance:",
  description: "Descrição",
  makeBid: "Fazer Lance",
  yourBid: "Seu Lance",
  minValue: "Valor mínimo:",
  yourHighest: "Seu maior lance:",
  bidHistory: "Histórico de Lances",
  noBids: "Ainda não há lances neste leilão",
  prevImage: "Imagem anterior",
  nextImage: "Próxima imagem",
  loadingAuction: "Carregando leilão...",
  wheelTitle: "Roleta",
  wheelWelcome: "Bem-vinda! Gire sua roleta de boas-vindas e ganhe um presente especial!",
  wheelPhysical: "Ganhou presente físico? Envie seu depoimento em vídeo pelo WhatsApp para liberarmos o envio!",
  noSpin: "Nenhum giro disponível",
  spinExpiredAlert: "Seu giro expirou. Fale conosco no WhatsApp se ainda quiser resgatar.",
  spinExpiredBanner: "Seu giro expirou. Chama a gente no WhatsApp se quiser uma nova chance.",
  spinCta: "Girar a Roleta",
  sendVideoUnlock: "Envie o depoimento em vídeo pelo WhatsApp para liberarmos o envio do seu presente!",
  sendViaWa: "Enviar pelo WhatsApp",
  sendTestimonialWa: "Enviar depoimento no WhatsApp",
  prizeExclusive: (label) =>
    `Um(a) ${label} exclusivo(a) Madamy Closet! Para liberar o envio, mande um vídeo de depoimento pelo WhatsApp.`,
  hidePrefs: "Ocultar preferências",
  myPrefs: "Minhas preferências",
  hideHistory: "Ocultar histórico",
  myPrizes: "Meus prêmios",
  noPrizesYet: "Nenhum prêmio ainda. Gire a roleta!",
  pendingPrizePopup: "Você tem um prêmio pendente!",
  spinNow: "Girar!",
  pointsAndRef: "Pontos & Indicação",
  referFriendTitle: "Indique para sua amiga",
  earnPointsEach: "Ganhe",
  earnPointsEachAfter: "por cada amiga",
  referDescLong:
    "Compartilhe seu link exclusivo. Quando sua amiga se cadastrar, vocês duas ganham pontos. Se ela comprar, você ganha ainda mais!",
  copyLink: "Copiar Link",
  yourBalance: "Seu saldo",
  pointsSuffix: "pontos",
  howEarn: "Como ganhar pontos",
  ruleSignup: "Cadastro",
  ruleRefer: "Indicar amiga",
  newsLoading: "Carregando, aguarde...",
  noNews: "Nenhuma novidade disponível.",
  newsAll: "Todas",
  newsKind: {
    bolsa: "Bolsa",
    cinto: "Cinto",
    oculos: "Óculos",
    calcado: "Calçado",
    carteira: "Carteira",
    relogio: "Relógio",
    lenco: "Lenço",
    joia: "Joia",
    outros: "Outros",
  },
  waitPhotos: "Aguarde alguns segundos. As fotos estão carregando!",
  likeHint: "Clique no ❤️ se gostou e mostraremos mais produtos assim!",
  newsAlt: "Novidade",
  loadingPhoto: "Carregando foto...",
  friendBought: "Amiga comprou",
  auctionBid: "Lance em leilão",
  yourReferrals: "Suas indicadas",
  friendsReferred: "Amigas indicadas",
  friendsCount: (n) => `${n} amigas`,
  noFriendsYet: "Nenhuma amiga indicada ainda. Compartilhe seu link!",
  activeBuyer: "Compradora ativa",
  registered: "Cadastrada",
  historyTitle: "Histórico",
  lastMoves: "Últimas movimentações",
  noMoves: "Nenhuma movimentação ainda.",
  typeWelcome: "Boas-vindas",
  typeReferral: "Indicação",
  typeReferralBuy: "Compra de indicada",
  typeDaily: "Login diário",
  congrats: "Parabéns! Você ganhou:",
  freeShipNext: "Frete grátis Nacional (Sedex) na sua próxima compra! Será aplicado automaticamente.",
  discountNext: "Seu desconto exclusivo será aplicado na próxima compra!",
  prefSavedOk: "Preferência salva!",
  prefAsk: "Tem preferência de cor, marca ou estilo?",
  prefPh: "Ex: Prefiro cinto marrom, pulseira dourada...",
  saving: "Salvando...",
  savePref: "Salvar preferência",
  continue: "Continuar",
  likeCta: "Gostou? Tire print e clique aqui para comprar",
  linkCopied: "Link copiado!",
  copyFail: "Não foi possível copiar.",
  loadPointsErr: "Erro ao carregar dados de pontos.",
  shareRefMsg: (link) =>
    `Amiga, entra nesse app comigo! Tem promoções incríveis de luxo 👜✨\n\n${link}`,
  redeem: "Resgate",
  added: "Adicionou",
  addPiece: "Adicionar esta peça",
  addMore: "Adicionar mais uma desta",
  addPrice: (p) => `Adicionar · ${p}`,
  cart: "Carrinho",
  cartEmpty: "Nenhuma peça ainda. Toca em Adicionar na foto.",
  seePhoto: "Ver foto maior",
  toConfirm: "a confirmar",
  readingPrice: "Lendo o valor da foto…",
  closeOrder: "Fechar pedido",
  sendingBot: "Fechando pedido…",
  closeFail: "Não fechou. Tenta de novo ou chama o suporte.",
  cartSaved: "Pedido enviado. Te levamos ao canal de vendas com a lista.",
  cartNotSaved: "Não gravou o carrinho. Chama o suporte se precisar.",
  botUnreach: "Não alcançou o servidor. Tenta de novo.",
  needLogin: "Entra na sua conta pra fechar o pedido.",
  favorites: "Favoritos",
  favEmpty: "Nada salvo ainda. Nas promoções, toca no coração.",
  howTo: "Como usar",
  info1: "Abre Promoções de Hoje ou Super Promo e desliza as fotos.",
  info2: "Toca em Adicionar — a peça entra no Carrinho e o botão fica Adicionou.",
  info3: "Coração guarda em Favoritos. Toque na foto pra ver grande.",
  info4: "No Carrinho, clique em Fechar pedido. Abre o canal de vendas com a lista e o total.",
  talkSales: "Falar com suporte de vendas",
  salesChannel: "Canal de Vendas",
  infos: "Infos",
  menu: "Menu",
  cartAria: (n) => (n ? `Carrinho, ${n} peças` : "Carrinho"),
  closePhoto: "Fechar foto",
  tapClose: "Toque para fechar",
  pieceLarger: "Peça em tamanho maior",
  profileTitle: "Atualização de Cadastro",
  profileBody:
    "Precisamos do seu nome e WhatsApp pra te atender. Sem esses dados o app não abre.",
  needNamePhone: "Preenche seu nome e WhatsApp pra continuar.",
  needFullForm: "Completa nome, WhatsApp, marcas, gênero e o que quer na promo.",
  needVipForm: "Completa o cadastro: Instagram, 3 marcas, aniversário, gênero e o que quer na promo.",
  earnPointsComplete: (n) => `Ganhe ${n} Pontos ao completar`,
  profileErr: "Erro ao atualizar perfil. Confira a data (DD/MM/AAAA) e tente novamente.",
  profileCongrats: (n) => `Parabéns! Você ganhou ${n} pontos por completar seu cadastro!`,
  wonPending: (label) =>
    `Você ganhou um(a) ${label} e ainda não nos disse sua preferência.`,
  reconfirm: "Salvar e continuar",
};

const HOME_EN = {
  live: "LIVE",
  greeting: "Luxury Personal Shopper",
  welcome: "Welcome,",
  welcomeAccent: "friend.",
  subtitle:
    "Hand-picked pieces, rare finds and unique opportunities — the luxury you deserve, every day.",
  todayPromos: "Today's Promos",
  customizePromo: "Customize promo",
  auctions: "Auctions",
  auctionsOpen: (n) => `${n} auction${n > 1 ? "s" : ""} open now!`,
  auctionsEmpty: "Auctions off — catch deals in the VIP group",
  seeAllAuctions: "See all auctions",
  news: "News",
  newsSub: "Updates from the club.",
  superPromos: "Super Promos",
  superPromosSub: "Exclusive combos at unbeatable prices!",
  newBadge: "NEW",
  gift: "Get a Gift",
  giftSub: "Spin the wheel and win prizes!",
  testimonial: "Send your Testimonial",
  testimonialSub: "Send a video on WhatsApp and unlock your gift!",
  explore: "Explore",
  refer: "Refer Friends",
  referDesc: "Earn points for every referral.",
  points: "My Points",
  pointsDesc: "See your balance and history.",
  instagram: "Instagram",
  instagramDesc: "Behind the scenes, drops and news.",
  website: "Our Website",
  websiteDesc: "Full catalog and contact.",
  talk: "Talk to Us",
  feedback: "Feedback & Suggestions",
  send: "Send",
  install: "Install the app for the best experience",
  installTitle: "Install our app",
  installAndroid:
    "Tap the prompt at the bottom of the page, or add the app to your home screen",
  installIos: "Follow the steps below and install the app on your device",
  installApp: "Install App",
  step1: "Tap the share icon in the browser",
  step2: 'Find "Add to Home Screen"',
  step3: "Add the app to your home screen",
  add: "Add",
  sendTestimonial: "Send your Testimonial",
  loadingHistory: "Loading your history...",
  approved: "Testimonial Approved!",
  reviewing: "Testimonial under review",
  approvedBody: "Your video was approved and may appear in our Stories. Thank you for sharing.",
  reviewingBody: "We received your video and are reviewing it. Your wheel spin was already credited!",
  sentOn: "Sent on",
  close: "Close",
  testimonialSent: "Testimonial sent!",
  testimonialSentBody: "Thank you for sharing your experience! Your wheel spin was credited.",
  testimonialDesc:
    "Send a short video about your experience with Madamy Closet on WhatsApp — faster, no size limit.",
  rule1: "Record a video about the piece and the delivery",
  rule2: "Send it on Madamy Closet WhatsApp",
  rule3: "Then we release your wheel gift",
  openWa: "Open WhatsApp",
  thanksFeedback: "Thank you for the feedback!",
  thanksFeedbackBody: "Your opinion matters. We'll review your suggestion carefully.",
  feedbackDesc: "Tell us what you think of the app, what we can improve, or what you'd like to see.",
  feedbackPh: "Write your suggestion here...",
  sendFeedback: "Send Feedback",
  ticker:
    "✨ 100% authentic pieces  •  📦 Worldwide shipping  •  💎 Daily exclusive curation  •  ⭐ +500 happy clients  •  🔒 Safe checkout  •  💳 Pay in up to 12 installments  •  🎁 Gift for new members  •  ",
  ended: "Ended",
  currentBid: "Current bid",
  bids: "bids",
  seeAuctions: "See Auctions",
  liveAuction: "LIVE AUCTION",
  spinLine: (n) => `You have ${n} spin${n > 1 ? "s" : ""} on the Gift Wheel!`,
  nextBenefit: "Your next perk:",
  nextBuy: "— on your next order!",
  freeShip: "Free national shipping (express)",
  testimonialAlert: "Send your video testimonial on WhatsApp to release the gift. Tap here.",
  dispute: "Bid on exclusive pieces.",
  seeProducts: "See products →",
  exclusiveVip: "VIP EXCLUSIVE",
  soldOut: "SOLD OUT",
  noProduct: "No products",
  unitPrice: "Boutique",
  storeLabel: "Store price",
  ourPrice: "Our price",
  wantBuy: "I want to buy",
  superTitle: "Super Promos",
  superSub: "Exclusive combos at unbeatable prices",
  surpriseKicker: "Surprise drop",
  surpriseTitle: "Today's Super Promos unlock at 06:00",
  surpriseBody: "Watch the clock. Early birds get the new kit.",
  noPromo: "More dropping any moment.",
  noPromoTitle: "Closed for today",
  back: "Back",
  oops: "Oops! Something went wrong",
  oopsBody: "We're working on it. Try reloading the page.",
  reload: "Reload",
  notFound: "Page not found",
  backHome: "Back to Home",
  bags: "Bags",
  travel: "Travel bags",
  watches: "Watches",
  accessories: "Accessories",
  jewelry: "Jewelry",
  clothes: "Ready-to-wear",
  shoes: "Shoes",
  other: "Other",
  storyLabels: { leilao: "Auction", achados: "Finds", depoimentos: "Clients", envios: "Shipping", duvidas: "FAQ" },
  loadingDots: "Loading...",
  piece: "piece",
  pieces: "pieces",
  availableCount: (n) => `${n} piece${n !== 1 ? "s" : ""} available`,
  removeFav: "Remove from favorites",
  saveFav: "Save to favorites",
  pieceNoun: "Piece",
  notifyTitle: "Turn on notifications!",
  notifyBody: "Install the app to get alerts for new auctions and live bids.",
  wishAsk: "What do you want to see at auction?",
  wishHint: "Tap here and suggest your dream piece",
  wishSentBanner: "✨ Suggestion sent! Thank you!",
  filterActive: "Live",
  filterSoon: "Upcoming",
  filterEnded: "Ended",
  loadAuctionsErr: "Could not load auctions",
  wishSendErr: "Could not send suggestion",
  noAuctionActive: "No live auctions right now",
  auctionOffTitle: "Auctions off for now",
  auctionOffBody: "Stay tuned in the VIP group — opportunities drop there first. Turn on notifications on our channels.",
  auctionOffGroupCta: "Join VIP group",
  auctionOffNotifyHint: "Enable app notifications and watch WhatsApp so you don't miss the next auction.",
  auctionsEmptyOff: "Auctions off — catch deals in the VIP group",
  noAuctionSoon: "No upcoming auctions",
  noAuctionEnded: "No ended auctions",
  loadingAuctions: "Loading auctions...",
  placeBid: "Place Bid",
  wishThanksTitle: "Thanks for the suggestion!",
  wishThanksBody: "We'll review it and bring it to the next auction.",
  wishPopupTitle: "What do you want to see at auction?",
  wishPopupSub: "Tell us the piece or house you dream of winning!",
  category: "Category",
  yourSuggestion: "Your suggestion",
  wishPlaceholder: "e.g. Chanel Classic Flap, Louis Vuitton Trainer...",
  sending: "Sending...",
  sendSuggestion: "Send Suggestion",
  auctionDetails: "Auction Details",
  loadAuctionErr: "Could not load auction",
  auctionNotFound: "Auction not found",
  minBidToast: (v) => `Minimum bid: R$ ${v}`,
  bidOk: "Bid placed!",
  bidFail: "Could not place bid",
  highestBidder: "Highest bidder:",
  description: "Description",
  makeBid: "Place a Bid",
  yourBid: "Your Bid",
  minValue: "Minimum:",
  yourHighest: "Your highest bid:",
  bidHistory: "Bid History",
  noBids: "No bids on this auction yet",
  prevImage: "Previous image",
  nextImage: "Next image",
  loadingAuction: "Loading auction...",
  wheelTitle: "Wheel",
  wheelWelcome: "Welcome! Spin your welcome wheel and win a special gift!",
  wheelPhysical: "Won a physical gift? Send a video testimonial on WhatsApp so we can ship it!",
  noSpin: "No spins available",
  spinExpiredAlert: "Your spin expired. Message us on WhatsApp if you still want to redeem.",
  spinExpiredBanner: "Your spin expired. Message us on WhatsApp if you want another chance.",
  spinCta: "Spin the Wheel",
  sendVideoUnlock: "Send a video testimonial on WhatsApp so we can ship your gift!",
  sendViaWa: "Send on WhatsApp",
  sendTestimonialWa: "Send testimonial on WhatsApp",
  prizeExclusive: (label) =>
    `An exclusive ${label} from Madamy Closet! To unlock shipping, send a video testimonial on WhatsApp.`,
  hidePrefs: "Hide preferences",
  myPrefs: "My preferences",
  hideHistory: "Hide history",
  myPrizes: "My prizes",
  noPrizesYet: "No prizes yet. Spin the wheel!",
  pendingPrizePopup: "You have a pending prize!",
  spinNow: "Spin!",
  pointsAndRef: "Points & Referral",
  referFriendTitle: "Refer a friend",
  earnPointsEach: "Earn",
  earnPointsEachAfter: "for each friend",
  referDescLong:
    "Share your exclusive link. When your friend registers, you both earn points. If she buys, you earn even more!",
  copyLink: "Copy Link",
  yourBalance: "Your balance",
  pointsSuffix: "points",
  howEarn: "How to earn points",
  ruleSignup: "Sign up",
  ruleRefer: "Refer a friend",
  newsLoading: "Loading, please wait...",
  noNews: "No news available.",
  newsAll: "All",
  newsKind: {
    bolsa: "Bags",
    cinto: "Belts",
    oculos: "Sunglasses",
    calcado: "Shoes",
    carteira: "Wallets",
    relogio: "Watches",
    lenco: "Scarves",
    joia: "Jewelry",
    outros: "Other",
  },
  waitPhotos: "Give it a few seconds. Photos are loading!",
  likeHint: "Tap ❤️ if you like it and we'll show more like this!",
  newsAlt: "News",
  loadingPhoto: "Loading photo...",
  friendBought: "Friend purchased",
  auctionBid: "Auction bid",
  yourReferrals: "Your referrals",
  friendsReferred: "Friends referred",
  friendsCount: (n) => `${n} friend${n !== 1 ? "s" : ""}`,
  noFriendsYet: "No referrals yet. Share your link!",
  activeBuyer: "Active buyer",
  registered: "Signed up",
  historyTitle: "History",
  lastMoves: "Latest activity",
  noMoves: "No activity yet.",
  typeWelcome: "Welcome",
  typeReferral: "Referral",
  typeReferralBuy: "Referral purchase",
  typeDaily: "Daily login",
  congrats: "Congratulations! You won:",
  freeShipNext: "Free national shipping (express) on your next order! Applied automatically.",
  discountNext: "Your exclusive discount will apply on the next order!",
  prefSavedOk: "Preference saved!",
  prefAsk: "Any color, brand or style preference?",
  prefPh: "e.g. Brown belt, gold bracelet...",
  saving: "Saving...",
  savePref: "Save preference",
  continue: "Continue",
  likeCta: "Like it? Screenshot and tap here to buy",
  linkCopied: "Link copied!",
  copyFail: "Could not copy.",
  loadPointsErr: "Could not load points.",
  shareRefMsg: (link) =>
    `Join me on this luxury personal shopper app 👜✨\n\n${link}`,
  redeem: "Redeem",
  added: "Added",
  addPiece: "Add this piece",
  addMore: "Add another of this",
  addPrice: (p) => `Add · ${p}`,
  cart: "Cart",
  cartEmpty: "Nothing yet. Tap Add on the photo.",
  seePhoto: "See larger photo",
  toConfirm: "to confirm",
  readingPrice: "Reading the price from the photo…",
  closeOrder: "Close order",
  sendingBot: "Closing order…",
  closeFail: "Could not close. Try again or message support.",
  cartSaved: "Order sent. We are opening the sales channel with your list.",
  cartNotSaved: "Cart was not saved. Message support if you need help.",
  botUnreach: "Could not reach the server. Try again.",
  needLogin: "Sign in to close your order.",
  favorites: "Favorites",
  favEmpty: "Nothing saved yet. In promos, tap the heart.",
  howTo: "How to use",
  info1: "Open Today's Promos or Super Promos and swipe the photos.",
  info2: "Tap Add — the piece goes to the Cart and the button becomes Added.",
  info3: "The heart saves to Favorites. Tap the photo to see it large.",
  info4: "In the Cart, tap Close order. The sales channel opens with the list and total.",
  talkSales: "Talk to sales support",
  salesChannel: "Sales Channel",
  infos: "Info",
  menu: "Menu",
  cartAria: (n) => (n ? `Cart, ${n} pieces` : "Cart"),
  closePhoto: "Close photo",
  tapClose: "Tap to close",
  pieceLarger: "Larger piece",
  profileTitle: "Profile update",
  profileBody:
    "We need your name and WhatsApp to help you. The app stays locked until those are filled.",
  needNamePhone: "Enter your name and WhatsApp to continue.",
  needFullForm: "Complete name, WhatsApp, brands, gender and what you want on promo.",
  needVipForm: "Complete registration: Instagram, 3 brands, birthday, gender and what you want on promo.",
  earnPointsComplete: (n) => `Earn ${n} points when you finish`,
  profileErr: "Could not update profile. Check the date (DD/MM/YYYY) and try again.",
  profileCongrats: (n) => `Congratulations! You earned ${n} points for completing your profile!`,
  wonPending: (label) =>
    `You won a ${label} and have not told us your preference yet.`,
  reconfirm: "Save and continue",
};

const HOME_ES = {
  ...HOME_EN,
  greeting: "Personal Shopper de Lujo",
  welcome: "Bienvenida,",
  welcomeAccent: "amiga.",
  todayPromos: "Promos de hoy",
  news: "Novedades",
  newsSub: "Novedades del club.",
  newsAll: "Todas",
  newsKind: {
    bolsa: "Bolso",
    cinto: "Cinturón",
    oculos: "Gafas",
    calcado: "Calzado",
    carteira: "Cartera",
    relogio: "Reloj",
    lenco: "Pañuelo",
    joia: "Joya",
    outros: "Otros",
  },
  superPromos: "Super Promos",
  superPromosSub: "Combos exclusivos a precios irresistibles.",
  likeHint: "Toca el ❤️ si te gusta y te mostraremos más así.",
  likeCta: "¿Te gustó? Captura o toca aquí para comprar",
  pieceNoun: "Pieza",
  loadingDots: "Cargando...",
  noNews: "No hay novedades.",
  back: "Volver",
  add: "Agregar",
  cart: "Carrito",
  waitPhotos: "Unos segundos. Las fotos están cargando.",
  storeLabel: "Precio en tienda",
  ourPrice: "Nuestro precio",
  added: "Agregado",
  addPiece: "Agregar esta pieza",
  addMore: "Agregar otra de esta",
  addPrice: (p) => `Agregar · ${p}`,
  cartEmpty: "Ninguna pieza aún. Toca Agregar en la foto.",
  closeOrder: "Cerrar pedido",
  toConfirm: "a confirmar",
  readingPrice: "Leyendo el precio…",
  storyLabels: { leilao: "Subasta", achados: "Hallazgos", depoimentos: "Clientes", envios: "Envíos", duvidas: "Dudas" },
};

const HOME_RU = {
  ...HOME_EN,
  greeting: "Люксовый Personal Shopper",
  welcome: "Добро пожаловать,",
  welcomeAccent: "друг.",
  todayPromos: "Акции сегодня",
  news: "Новинки",
  newsSub: "Новости клуба.",
  newsAll: "Все",
  newsKind: {
    bolsa: "Сумки",
    cinto: "Ремни",
    oculos: "Очки",
    calcado: "Обувь",
    carteira: "Кошельки",
    relogio: "Часы",
    lenco: "Платки",
    joia: "Украшения",
    outros: "Другое",
  },
  superPromos: "Super Promos",
  superPromosSub: "Эксклюзивные комбо по лучшим ценам.",
  likeHint: "Нажмите ❤️, если нравится — покажем похожие.",
  likeCta: "Нравится? Скриншот или нажмите, чтобы купить",
  pieceNoun: "Вещь",
  loadingDots: "Загрузка...",
  noNews: "Новостей нет.",
  back: "Назад",
  add: "Добавить",
  cart: "Корзина",
  waitPhotos: "Секунду. Фото загружаются.",
  storeLabel: "Цена в магазине",
  ourPrice: "Наша цена",
  added: "Добавлено",
  addPiece: "Добавить эту вещь",
  addMore: "Добавить ещё одну",
  addPrice: (p) => `Добавить · ${p}`,
  cartEmpty: "Пока пусто. Нажмите Добавить на фото.",
  closeOrder: "Оформить заказ",
  toConfirm: "уточним",
  readingPrice: "Читаем цену…",
  storyLabels: { leilao: "Аукцион", achados: "Находки", depoimentos: "Клиенты", envios: "Доставка", duvidas: "Вопросы" },
};

const STORY_SLIDES_EN = {
  leilao: [
    { title: "Auction is live!", text: "Exclusive designer pieces with bids from $1. Don't miss it." },
    { title: "How to join?", text: "1. Open Auctions\n2. Pick a piece\n3. Place your bid\n4. Watch live and win!" },
    { title: "Designer pieces", text: "Bags, accessories and rare finds from the world's best houses. Authenticated, auction prices only." },
  ],
  achados: [
    { title: "Exclusive curation", text: "Our personal shoppers pick the best luxury pieces for you." },
    { title: "Rare pieces", text: "Finds you won't see everywhere. Limited models and special editions." },
    { title: "Special prices", text: "Member-only discounts. Save up to 40% on authenticated designer pieces." },
  ],
  depoimentos: [
    { title: '"I loved my bag!"', text: '"Arrived so fast and exactly like the photos. Impeccable quality. Already looking at the next one." — Ana C.' },
    { title: '"Service is a 10"', text: '"The team is amazing — they helped me pick the perfect gift. So attentive!" — Juliana M.' },
    { title: '"I\'m a regular now"', text: '"Third order and it keeps getting better. Authentic pieces, fair prices, flawless delivery." — Carla R.' },
  ],
  envios: [
    { title: "We ship worldwide", text: "Fast, insured delivery with full tracking. Packed with care." },
    { title: "Premium packaging", text: "Every piece is wrapped like the luxury gift you deserve." },
    { title: "100% secure", text: "Every piece is authenticated and shipped insured. Protected from start to finish." },
  ],
  duvidas: [
    { title: "How it works", text: "We're a luxury personal shopper. We source the best pieces and bring them to you at exclusive prices. 100% authentic." },
    { title: "Payment", text: "We accept card (up to 12x), transfer and invoice. Secure checkout. Pick what works for you." },
    { title: "Returns", text: "You have 7 days after delivery to request a return or exchange. Just message support. Simple." },
    { title: "Talk to us", text: "Questions? Our team is on WhatsApp and Instagram. Fast, human support." },
  ],
};

export function appCopy(locale) {
  const home =
    locale === "en" ? HOME_EN : locale === "es" ? HOME_ES : locale === "ru" ? HOME_RU : HOME_PT;
  return { ...authCopy(locale), ...home };
}

export function localizeStories(stories, locale) {
  if (locale !== "en" && locale !== "es" && locale !== "ru") return stories;
  const labels = (locale === "es" ? HOME_ES : locale === "ru" ? HOME_RU : HOME_EN).storyLabels;
  return stories.map((story) => {
    const slidesEn = STORY_SLIDES_EN[story.id];
    const label = labels[story.id] || story.label;
    if (!slidesEn) return { ...story, label };
    return {
      ...story,
      label,
      slides: story.slides.map((slide, i) =>
        slide.auction ? slide : { ...slide, ...(slidesEn[i] || {}) }
      ),
    };
  });
}
